// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__1QctD","open":"Modal_open__19sDd","wrapper":"Modal_wrapper__2rdba","content":"Modal_content__2EI7J"};